<template>
  <div class="question-item">
    <img class="q-image" :src="data.list_icon" alt="" />
    <div class="q-right">
      <div class="q-title">{{ data.que_title }}</div>
      <div class="q-desc">{{ data.que_explain }}</div>
      <div class="q-btm">
        <div class="q-info"
          ><span class="purple"
            ><span class="iconfont icon-guankanrenshu"></span
            >{{ data.realityUseNum | filterNumber }}</span
          ><span v-if="data.isStatistics == 1"
            >人｜{{ data.que_answer_num }}题</span
          >
        </div>
        <div v-if="self"
          ><span class="result" @click="bindResult">查看结果</span
          ><span
            class="re-test"
            v-if="data.state == 1 && data.que_allow_num != 1"
            @click="bindReTest"
            >重新测试<span class="iconfont icon-you"></span></span
        ></div>
        <div v-else class="q-btn" @click="bindClick">{{
          data.que_attr == 0 ? '立即测试' : '立即参与'
        }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    self: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  filters: {
    filterNumber(num) {
      num = +num
      if (num <= 999) {
        return num
      } else if (num > 999 && num < 9999) {
        return parseFloat((num / 1000).toFixed(1)) + 'k'
      } else {
        return parseFloat((num / 10000).toFixed(1)) + 'w'
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    bindClick() {
      this.$emit('click', this.data, 1)
    },
    bindResult() {
      this.$emit('click', this.data, 2)
    },
    bindReTest() {
      this.$emit('click', this.data, 3)
    }
  }
}
</script>
<style lang="scss" scoped>
.question-item {
  display: flex;
  align-items: center;
  padding: 18px 16px;
  background: #ffffff;
  box-shadow: 0px 0px 16px 0px rgba(225, 224, 231, 0.3);
  border-radius: 12px;
  margin-bottom: 16px;

  .q-image {
    width: 60px;
    height: 80px;
    overflow: hidden;
    object-fit: contain;
    border-radius: 8px;
    margin-right: 15px;
  }

  .q-right {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;

    .q-title {
      font-size: 15px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 21px;
      margin-bottom: 4px;
    }

    .q-desc {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .q-btm {
      margin-top: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .q-info {
        font-size: 10px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.3);
        line-height: 14px;

        .iconfont {
          font-size: 10px;
          margin-right: 2px;
        }

        .purple {
          color: #ad96ff;
        }
      }

      .result {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.3);
        line-height: 16px;
        text-decoration: underline;
        margin-right: 14px;
      }

      .re-test {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #ff7d1b;
        line-height: 16px;
        display: inline-flex;
        align-items: center;
      }

      .q-btn {
        height: 26px;
        background: linear-gradient(270deg, #cfbeff 0%, #ad96ff 100%);
        border-radius: 13px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 26px;
        padding: 0px 14px;
      }
    }
  }
}
</style>
